import { Map } from 'immutable';
import { Userpilot } from 'userpilot';
import * as types from './AuthActionTypes';

export default function AuthReducer(state = Map({ admin: null }), action) {
  switch (action.type) {
    case types.LOGIN_SUCCESS:
      sessionStorage.setItem('admin', JSON.stringify(action.loggedInAdmin));
      identifyAdmin(action.loggedInAdmin);
      return state.set('admin', action.loggedInAdmin);
    case types.LOGIN_FAILURE:
      return state.set('admin', null);
    case types.SIGNOUT_USER:
      return state.set('admin', null);
    case types.SET_ADMIN:
      identifyAdmin(action.admin);
      return state.set('admin', action.admin);
    case types.SWITCH_ADMIN:
      sessionStorage.setItem('admin', JSON.stringify(action.admin));
      identifyAdmin(action.admin);
      return state.set('admin', action.admin);
    default:
      return state;
  }
}

const identifyAdmin = (admin) => {
  const { id, email, company } = admin;
  // identify user in Hotjar
  if (window.hj && typeof (window.hj) === 'function') {
    window.hj('identify', id, {
      email,
    });
  }
  // identify user in Userpilot
  Userpilot.identify(id, {
    email,
    company: {
      id: company.id,
      name: company.name,
    },
  });
};
